import { useQuery } from '@tanstack/react-query';
import { searchAPI } from '../services/api/search';
import type { SearchResponse, QuickSearchResponse, SearchScope } from '../services/api/search';
import { unwrapResponse } from '../utils/unwrapResponse';

/**
 * Full cross-pillar search hook with results, snippets, and metadata.
 * Requires minimum 2 characters to fire.
 */
export function useSearch(query: string, options?: { scope?: SearchScope; limit?: number; offset?: number }) {
  return useQuery<SearchResponse>({
    queryKey: ['search', query, options?.scope, options?.limit, options?.offset],
    queryFn: async () => {
      const res = await searchAPI.search(query, options);
      return unwrapResponse<any>(res.data);
    },
    enabled: query.trim().length >= 2,
    staleTime: 60_000,
  });
}

/**
 * Quick search hook for typeahead (minimal payload, fast).
 * Requires minimum 2 characters to fire.
 */
export function useQuickSearch(query: string, limit = 5) {
  return useQuery<QuickSearchResponse>({
    queryKey: ['search-quick', query, limit],
    queryFn: async () => {
      const res = await searchAPI.quick(query, limit);
      return unwrapResponse<any>(res.data);
    },
    enabled: query.trim().length >= 2,
    staleTime: 60_000,
  });
}
